import axios from 'axios';

class VersionApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }

    list() {
        return axios.get(`${this.endpoint}/app/versions`, {}).then(response=>response.data);
    }

    get(versionId) {
        return axios.get(`${this.endpoint}/app/versions/${versionId}`, {}).then(response=>response.data);
    }

    save(version) {
        return axios.post(`${this.endpoint}/app/version/save`, version).then(response=>response);
    }

    delete(versionId) {
        return axios.delete(`${this.endpoint}/app/version/delete/${versionId}`, {}).then(response=>response.data);
    }


}


export default new VersionApi();
